import { FlexDiv } from 'components/generic/HomePageComponents'
import { CenteredDiv, MainDiv, Header } from './Styled'
import ColouredTextItems from './ColouredTextItems'
import Cities from './Cities'

const CareguideFamily = ({ header, colouredTextItems, cities, siteName }) => {
  return (
    <MainDiv>
      <CenteredDiv>
        <Header ml='10px' mr='10px'>
          {siteName} {header}
        </Header>
        <FlexDiv flexWrap='wrap' justifyContent='center' mb='20px'>
          <ColouredTextItems colouredTextItems={colouredTextItems} domain={siteName} />
        </FlexDiv>
        <FlexDiv flexWrap='wrap' alignSelf='center' maxWidth='950px' flexDirection='row'>
          <Cities cities={cities} domain={siteName} />
        </FlexDiv>
      </CenteredDiv>
    </MainDiv>
  )
}

export default CareguideFamily
